/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GoogleAnalyticsAttributionShadowCandidateData
 */
export interface GoogleAnalyticsAttributionShadowCandidateData {
    /**
     * 
     * @type {string}
     * @memberof GoogleAnalyticsAttributionShadowCandidateData
     */
    evidenceId?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleAnalyticsAttributionShadowCandidateData
     */
    integrationId?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleAnalyticsAttributionShadowCandidateData
     */
    evidenceSource?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleAnalyticsAttributionShadowCandidateData
     */
    accountId?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleAnalyticsAttributionShadowCandidateData
     */
    propertyId?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleAnalyticsAttributionShadowCandidateData
     */
    date?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleAnalyticsAttributionShadowCandidateData
     */
    rawTransactionId?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleAnalyticsAttributionShadowCandidateData
     */
    normalizedTransactionId?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleAnalyticsAttributionShadowCandidateData
     */
    ecommercePurchases?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleAnalyticsAttributionShadowCandidateData
     */
    purchaseRevenue?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleAnalyticsAttributionShadowCandidateData
     */
    currencyCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GoogleAnalyticsAttributionShadowCandidateData
     */
    completeness?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleAnalyticsAttributionShadowCandidateData
     */
    googleAdsCustomerId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GoogleAnalyticsAttributionShadowCandidateData
     */
    googleAdsCampaignId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GoogleAnalyticsAttributionShadowCandidateData
     */
    gclid?: string | null;
}

/**
 * Check if a given object implements the GoogleAnalyticsAttributionShadowCandidateData interface.
 */
export function instanceOfGoogleAnalyticsAttributionShadowCandidateData(value: object): value is GoogleAnalyticsAttributionShadowCandidateData {
    return true;
}

export function GoogleAnalyticsAttributionShadowCandidateDataFromJSON(json: any): GoogleAnalyticsAttributionShadowCandidateData {
    return GoogleAnalyticsAttributionShadowCandidateDataFromJSONTyped(json, false);
}

export function GoogleAnalyticsAttributionShadowCandidateDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoogleAnalyticsAttributionShadowCandidateData {
    if (json == null) {
        return json;
    }
    return {
        
        'evidenceId': json['evidenceId'] == null ? undefined : json['evidenceId'],
        'integrationId': json['integrationId'] == null ? undefined : json['integrationId'],
        'evidenceSource': json['evidenceSource'] == null ? undefined : json['evidenceSource'],
        'accountId': json['accountId'] == null ? undefined : json['accountId'],
        'propertyId': json['propertyId'] == null ? undefined : json['propertyId'],
        'date': json['date'] == null ? undefined : json['date'],
        'rawTransactionId': json['rawTransactionId'] == null ? undefined : json['rawTransactionId'],
        'normalizedTransactionId': json['normalizedTransactionId'] == null ? undefined : json['normalizedTransactionId'],
        'ecommercePurchases': json['ecommercePurchases'] == null ? undefined : json['ecommercePurchases'],
        'purchaseRevenue': json['purchaseRevenue'] == null ? undefined : json['purchaseRevenue'],
        'currencyCode': json['currencyCode'] === undefined ? undefined : json['currencyCode'] === null ? null : json['currencyCode'],
        'completeness': json['completeness'] == null ? undefined : json['completeness'],
        'googleAdsCustomerId': json['googleAdsCustomerId'] === undefined ? undefined : json['googleAdsCustomerId'] === null ? null : json['googleAdsCustomerId'],
        'googleAdsCampaignId': json['googleAdsCampaignId'] === undefined ? undefined : json['googleAdsCampaignId'] === null ? null : json['googleAdsCampaignId'],
        'gclid': json['gclid'] === undefined ? undefined : json['gclid'] === null ? null : json['gclid'],
    };
}

export function GoogleAnalyticsAttributionShadowCandidateDataToJSON(json: any): GoogleAnalyticsAttributionShadowCandidateData {
    return GoogleAnalyticsAttributionShadowCandidateDataToJSONTyped(json, false);
}

export function GoogleAnalyticsAttributionShadowCandidateDataToJSONTyped(value?: GoogleAnalyticsAttributionShadowCandidateData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'evidenceId': value['evidenceId'],
        'integrationId': value['integrationId'],
        'evidenceSource': value['evidenceSource'],
        'accountId': value['accountId'],
        'propertyId': value['propertyId'],
        'date': value['date'],
        'rawTransactionId': value['rawTransactionId'],
        'normalizedTransactionId': value['normalizedTransactionId'],
        'ecommercePurchases': value['ecommercePurchases'],
        'purchaseRevenue': value['purchaseRevenue'],
        'currencyCode': value['currencyCode'],
        'completeness': value['completeness'],
        'googleAdsCustomerId': value['googleAdsCustomerId'],
        'googleAdsCampaignId': value['googleAdsCampaignId'],
        'gclid': value['gclid'],
    };
}

